var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.388235 0 0 0 0 0.458824 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#515A65",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63620523 4.42263207L1.47647628 7.8236949c-.21839303.23507347-.5715392.23507347-.7876089 0l-.52507261-.56517661c-.21839303-.23507346-.21839303-.61519225 0-.84776493L2.403485 4 .16379477 1.58924664c-.21839303-.23507346-.21839303-.61519225 0-.84776493L.68886738.1763051c.21839303-.23507347.5715392-.23507347.7876089 0l3.15972895 3.40106283c.21839303.23007189.21839303.61019068 0 .84526414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36379477 4.42263207L6.52352372 7.8236949c.21839303.23507347.5715392.23507347.7876089 0l.52507261-.56517661c.21839303-.23507346.21839303-.61519225 0-.84776493L5.596515 4l2.23969023-2.41075336c.21839303-.23507346.21839303-.61519225 0-.84776493L7.31113262.1763051c-.21839303-.23507347-.5715392-.23507347-.7876089 0L3.36379477 3.57736793c-.21839303.23007189-.21839303.61019068 0 .84526414z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.6c91bb52594ca0f1e91a3dc8cbc0faa9.svg";
export { ForwardRef as ReactComponent };